import {format} from 'date-fns';
import moment from 'moment';

export function toHumanReadableDate(inputDateStr: string): string {
  const inputMoment = moment.utc(inputDateStr);
  const currentMoment = moment.utc();

  if (inputMoment.isSame(currentMoment, 'day')) {
    return 'Today at ' + inputMoment.format('HH:mm:ss');
  } else {
    const relativeDays = inputMoment.fromNow(true);
    return `${relativeDays} ago at ${inputMoment.format('HH:mm:ss')}`;
  }
}

export const formatDate = (
  date: number | null | undefined,
  dateFormat: string = 'MMM dd HH:mm:ss'
) => {
  if (!date) {
    return format(new Date(), dateFormat);
  }
  return format(new Date(date), dateFormat);
};

export function isAtLeast24HoursAgo(timestamp: any): boolean {
  if (!timestamp) {
    return false;
  }
  const givenDate = new Date(timestamp);
  const currentDate = new Date();
  const date24HoursAgo = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);

  return givenDate <= date24HoursAgo;
}
